import React, { useEffect } from "react";
import { AppButton } from "@libs/zapi-ui/custom";
import { useOrganizationStore } from "@/zapi-frontend/stores/organization";

const selectClasses =
  "min-w-[200px] h-9 px-3 py-1 border border-gray-300 rounded-md text-[14px] bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

export const OrganizationPicker: React.FC = () => {
  const {
    currentOrganizationId,
    availableOrganizations,
    switchOrganization,
    isSystemAdmin,
    isLoading,
    loadOrganizations
  } = useOrganizationStore();

  useEffect(() => {
    if (isSystemAdmin) {
      loadOrganizations();
    }
  }, [isSystemAdmin, loadOrganizations]);

  if (!isSystemAdmin) {
    return null;
  }

  if (isLoading) {
    return (
      <AppButton appearance="outlined" disabled>
        Loading organizations...
      </AppButton>
    );
  }

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const orgId = parseInt(event.target.value);
    switchOrganization(orgId);
  };

  return (
    <select
      value={currentOrganizationId}
      onChange={handleSelectChange}
      className={selectClasses}
      title="Switch Organization"
    >
      {availableOrganizations.map((org) => (
        <option key={org.id} value={org.id}>
          {org.name}
        </option>
      ))}
    </select>
  );
};
